























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { StudyDummyBaseMethod } from '@/mixins/requests/student/StudyApis.vue'
import { QuestionAnswerType } from '@/mixins/requests/student/StudyApis.vue'

@Component({})
export default class StudyDummy2 extends Vue implements StudyDummyBaseMethod {
  @Prop()
  currentQuestionAnswer?: QuestionAnswerType

  public getQuestionAnswer(): QuestionAnswerType {
    // 録音データ（URL）を取得、APIに送信する時はBlobに戻す必要がある
    let element = document.getElementById('audio') as HTMLAudioElement
    return { inputs: [element.src] }
  }

  public restoreInputedElements(): void {
    // 入力値を復元
    if (!this.currentQuestionAnswer || !this.currentQuestionAnswer.inputs) return
    const value = this.currentQuestionAnswer.inputs[0]
    if (!value) return
    let element = document.getElementById('audio') as HTMLAudioElement
    if (element) element.src = value
  }

  public clearInputedElements(): void {
    // やり直し
    let element = document.getElementById('audio') as HTMLAudioElement
    if (element) element.src = ''
  }

  private mounted() {
    let scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', '/dummy/study/js/2.js')
    ;(document.getElementById('contentsarea2') as HTMLElement).appendChild(scriptEl)

    // 入力値を復元
    this.restoreInputedElements()
  }
}
